import { defineStore } from 'pinia'
import { ref, watchEffect } from 'vue'
import { cloneDeep, pick } from 'lodash'
import { useLoadShortSchedule } from '@/entities/Schedule'

export const useModel = defineStore('schedule_copy', () => {
  const editId = ref<number>(0)
  const openForm = ref(false)

  /* Данные формы */
  const fields: {
    id: number
    name: string
    group_object_list_id: number
  } = {
    id: 0,
    name: '',
    group_object_list_id: 1,
  }

  const data = ref(cloneDeep(fields))

  const loadData = () => {
    const result = useLoadShortSchedule(editId)

    watchEffect(() => {
      if (result.data.value) {
        data.value = pick(result.data.value.data, ['id', 'name', 'group_object_list_id'])
      }
    })

    return result
  }

  /** Устанавливаем значение группы по умолчанию */
  const setGroup = (groupId: number) => {
    data.value.group_object_list_id = groupId
  }

  /**
   * Функция очистки формы после закрытия
   */
  const closeForm = () => {
    openForm.value = false
    data.value = cloneDeep(fields)
  }

  return {
    data,
    openForm,
    editId,

    closeForm,
    loadData,
    setGroup,
  }
})
